export default __webpack_public_path__ + "c830abc5355053822da97ab9a99d76aa.png";